/**
 * Created by ivan on 10.04.18.
 */

const Toolbar = function () {
    this.items = [];
    this.freezed = false;

    this.onUpdateItemsListener = function () {};
    this.onAddItemListener = function () {};
    this.onEnableListener = function () {};
    this.onGetView = function () {};

    if (cleverapps.config.features.includes("map2d_location_common")) {
        if (typeof OrdersToolbarItem !== "undefined") {
            this.addItem(new OrdersToolbarItem());
        }
        if (typeof UnitsLibraryToolbarItem !== "undefined") {
            this.addItem(new UnitsLibraryToolbarItem());
        }
        if (typeof UnitShopToolbarItem !== "undefined") {
            this.addItem(new UnitShopToolbarItem());
        }
        if (typeof TravelBookToolbarItem !== "undefined") {
            this.addItem(new TravelBookToolbarItem());
        }
        if (cleverapps.dailyTasks) {
            this.addItem(new DailyTasksToolbarItem());
        }
        if (typeof ClansToolbarItem !== "undefined") {
            this.addItem(new ClansToolbarItem());
        }
        if (typeof MagnetToolbarItem !== "undefined") {
            this.addItem(new MagnetToolbarItem());
        }
        if (typeof DynamiteToolbarItem !== "undefined") {
            this.addItem(new DynamiteToolbarItem());
        }

        if (typeof FriendsListRequestsToolbarItem !== "undefined" && cleverapps.config.type !== "match3"
            && connector.platform.oneOf(connector.INSTANT, connector.DISCORD, connector.OK, connector.TEST)) {
            this.addItem(new FriendsListRequestsToolbarItem());
        }

        if (typeof AchievementsToolbarItem !== "undefined" && cleverapps.config.type !== "merge3") {
            this.addItem(new AchievementsToolbarItem());
        }
    }

    if (cleverapps.config.type === "battlefield") {
        if (typeof ArmyLibraryToolbarItem !== "undefined") {
            this.addItem(new ArmyLibraryToolbarItem());
        }
    } else if (["match3", "differences", "solitaire", "board", "tile3"].includes(cleverapps.config.type)) {
        this.addItem(new FriendRequestsToolbarItem());
        if (typeof MiniGameToolbarItem !== "undefined") {
            this.addItem(new MiniGameToolbarItem());
        }

        if (cleverapps.dailyTasks) {
            this.addItem(new DailyTasksToolbarItem());
        }

        if (typeof LeaguesToolbarItem !== "undefined") {
            this.addItem(new LeaguesToolbarItem());
        }

        this.addItem(new RewardedVideoToolbarItem());
    } else if (["blocks"].includes(cleverapps.config.type)) {
        if (typeof MiniGameToolbarItem !== "undefined") {
            this.addItem(new MiniGameToolbarItem());
        }
        this.addItem(new RewardedVideoToolbarItem());
        if (typeof LeaguesToolbarItem !== "undefined") {
            this.addItem(new LeaguesToolbarItem());
        }
        this.addItem(new FriendRequestsToolbarItem());
        if (cleverapps.dailyTasks) {
            this.addItem(new DailyTasksToolbarItem());
        }
    }

    if (typeof TravelMapToolbarItem !== "undefined") {
        this.addItem(new TravelMapToolbarItem());
    }

    if (typeof StickersBookToolbarItem !== "undefined") {
        this.addItem(new StickersBookToolbarItem());
    }

    if (typeof StickersBookToolbarItem2 !== "undefined") {
        this.addItem(new StickersBookToolbarItem2());
    }

    if (cleverapps.config.features.includes("weekly_goals")) {
        this.addItem(new WeeklyGoalsToolbarItem());
    }

    if (typeof MiniPromoToolbarItem !== "undefined") {
        this.addItem(new MiniPromoToolbarItem());
    }
};

Toolbar.prototype.getSceneItems = function () {
    return this.items.filter((item) => item.isAvailableOnScene());
};

Toolbar.prototype.anyItemWithForce = function () {
    for (let i = 0; i < this.items.length; i++) {
        const force = this.items[i].getForce();
        if (force && this.items[i].isVisible() && !cleverapps.forces.isShown(force)) {
            return this.items[i];
        }
    }

    return undefined;
};

Toolbar.prototype.showAnyForce = function () {
    const item = this.anyItemWithForce();

    cleverapps.focusManager.display({
        focus: "toolbarItemForce",
        control: "toolbar",
        actions: [
            function (f) {
                this.updateItems();
                cleverapps.timeouts.setTimeout(f, 500);
            }.bind(this),

            function (f) {
                cleverapps.focusManager.showControlsWhileFocused("toolbar");
                item.showForce();
                cleverapps.forces.onceForceClosed = f;
            }
        ]
    });
};

Toolbar.prototype.addItem = function (item) {
    if (this.getItem(item.type) !== undefined) {
        return;
    }
    this.items.push({});
    let index = this.items.length - 1;
    while (index > 0 && this.items[index - 1].type > item.type) {
        this.items[index] = this.items[index - 1];
        index--;
    }

    this.items[index] = item;

    this.onAddItemListener(item, index);
};

Toolbar.prototype.hasVisibleItems = function () {
    return this.items.filter((item) => item.isVisible()).length > 0;
};

Toolbar.prototype.resetByType = function (itemType) {
    const item = this.getItem(itemType.type);
    if (item) {
        item.resetState();
        this.updateItems();
    }
};

Toolbar.prototype.resetItemsState = function () {
    this.items.forEach((item) => {
        item.resetState && item.resetState();
    });
};

Toolbar.prototype.getItem = function (type) {
    for (let i = 0; i < this.items.length; ++i) {
        if (this.items[i].type === type) {
            return this.items[i];
        }
    }
    return undefined;
};

Toolbar.prototype.updateItems = function (silent) {
    if (this.freezed) {
        return;
    }

    this.onUpdateItemsListener(silent);
};

Toolbar.prototype.freezeUpdates = function () {
    this.freezed = true;
};

Toolbar.prototype.unfreezeUpdates = function () {
    this.freezed = false;
    this.updateItems();
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TOOLBAR_ITEM_TIMER_TEXT: {
        name: "default",
        size: 21
    },

    TOOLBAR_ITEM_REWARD_TEXT: {
        size: 28,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});
